// extracted by mini-css-extract-plugin
module.exports = {"pd":"productDetail_pd__3CtZ7","subTitle":"productDetail_subTitle__1XVfV","detail":"productDetail_detail__3I8HP"};